import { BusinessAccess } from '../hooks/useBusinessAccessInvitations';
import { getDestinationText } from './invitationDisplay';

export const convertToCSV = (data: any[], headers: string[]): string => {
  if (!data || data.length === 0) {
    return headers.join(',');
  }

  const csvRows = [];
  
  csvRows.push(headers.join(','));
  
  for (const row of data) {
    const values = headers.map(header => {
      const value = row[header];
      if (value === null || value === undefined) {
        return '';
      }
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    });
    csvRows.push(values.join(','));
  }
  
  return csvRows.join('\n');
};

export const downloadCSV = (csvContent: string, filename: string): void => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

export const flattenInvitationData = (invitation: BusinessAccess): Record<string, any> => {
  let type = 'Residential';
  if (invitation.entity === 'business_access') {
    type = 'Business';
  } else if (invitation.entity === 'invitation') {
    type = 'Residential';
  } else if (typeof invitation.business_access_type_id === 'number' && invitation.business_access_type_id === 2) {
    type = 'Business';
  }

  let destination = '';
  if (invitation.entity === 'business_access') {
    destination = invitation.business?.estate?.name || invitation.business_name || '';
  } else if (invitation.entity === 'invitation') {
    destination = getDestinationText(invitation) || invitation.estate?.name || '';
  } else {
    destination = invitation.business?.estate?.name || invitation.estate?.name || invitation.business_name || '';
  }


  const mainGuestName = invitation.main_guest 
    ? `${invitation.main_guest.name || ''} ${invitation.main_guest.last_name || ''}`.trim()
    : '';
  const mainGuestPhone = invitation.main_guest?.tel || '';


  const companionsCount = invitation.business_guest?.length || 0;


  const formatDate = (dateStr: string) => {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch {
      return dateStr;
    }
  };

  return {
    'Type': type,
    'Access Type': invitation.type_name || '',
    'Status': invitation.status_name || '',
    'Destination': destination,
    'Main Guest Name': mainGuestName,
    'Main Guest Phone': mainGuestPhone,
    'Companions': companionsCount,
    'Children': invitation.children_count || 0,
    'Start Date': formatDate(invitation.start_date),
    'End Date': formatDate(invitation.end_date),
    'Created Date': formatDate(invitation.create_date),
    'Code': invitation.id || invitation.code || '',
  };
};

/**
 * Export invitations to CSV
 */
export const exportInvitationsToCSV = (invitations: BusinessAccess[], filename?: string): void => {
  const headers = [
    'Type',
    'Access Type',
    'Status',
    'Destination',
    'Main Guest Name',
    'Main Guest Phone',
    'Companions',
    'Children',
    'Start Date',
    'End Date',
    'Created Date',
    'Code',
  ];

  const flattenedData = invitations.map(flattenInvitationData);
  const csvContent = convertToCSV(flattenedData, headers);
  
  const defaultFilename = `invitations_export_${new Date().toISOString().split('T')[0]}.csv`;
  downloadCSV(csvContent, filename || defaultFilename);
};
